import {auth} from '../../main'

export const user = {
  namespaced: true,
  state: {
    isLogin: false,
    uid: '',
    isAnonymous: true,
    displayName: '名無し',
    list: [],
    message: '',
    isUpdate: false
  },
  mutations: {
    init (state) {
      state.isLogin = false
      state.uid = ''
      state.isAnonymous = true
      // kastate.displayName = ''
      state.list = []
    },
    setUserData (state, u) {
      state.isLogin = true
      state.uid = u.uid
      state.isAnonymous = u.isAnonymous
      // state.displayName = u.displayName
    },
    setDisplayName (state, val) {
      state.displayName = val
    },
    addList (state, id) {
      state.list.push(id)
    },
    setMessage (state, val) {
      state.message = val
    },
    setIsUpdate (state, flag) {
      state.isUpdate = flag
    }
  },
  getters: {
  },
  actions: {
    async loginAnonymous ({commit}) {
      // commit('init')
      await auth.signInAnonymously().catch(function(error) {
        console.error(error)
      })
      await auth.onAuthStateChanged(function(user) {
        if (user) {
          // User is signed in.
          // var isAnonymous = user.isAnonymous;
          // var uid = user.uid;
          // user.updateProfile({
          //   displayName: "testUpdate"
          // })
          commit('setUserData', user)
        } else {
          console.error('匿名認証に失敗')
        }
      });
    },
    // addTodo ({state, commit}, id) {
    //   if (!state.list.find(l => l === id)) {
    //     commit('addList', id)
    //     console.log(state)
    //     db.collection(' ').doc(state.uid).set({
    //       list: state.list
    //     }, {merge: true})
    //   }
    // }
  }
}
